import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKopen = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="m26.063 7.212-15.037 3.76a1.25 1.25 0 0 0-.91 1.516l2.305 9.216a1.25 1.25 0 0 0 1.516.91l15.037-3.76a1.25 1.25 0 0 0 .91-1.517l-2.306-9.216a1.25 1.25 0 0 0-1.515-.91"
    />
    <path
      fill="#60D15D"
      d="M31.36 16H8.64a.64.64 0 0 0-.64.64v14.72c0 .354.287.64.64.64h22.72a.64.64 0 0 0 .64-.64V16.64a.64.64 0 0 0-.64-.64"
    />
    <path
      fill="#B3E9B1"
      d="M27.21 20.65h5a.53.53 0 0 1 .53.53v5.64a.53.53 0 0 1-.53.53h-5a3.35 3.35 0 1 1 0-6.7m0 5A1.68 1.68 0 1 0 25.54 24a1.68 1.68 0 0 0 1.67 1.68z"
    />
    <path
      fill="#fff"
      d="M32 15H8v1h24z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M15.24 30.23h-5.16v-1h5.16zM15.24 27.77h-5.16v-1h5.16z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M12.667 24.257A6 6 0 0 1 16.91 22.5v1a5 5 0 0 0 0 10v1a6 6 0 0 1-4.243-10.243M28.151 10.395l-17.47 4.36-.242-.97 17.47-4.36z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKopen);

export default ForwardRef;
